"use client";
import { ButtonDark } from "@/stories/Button.stories";
import { formatDurationToHoursAndMinutes, formatDurationToMinutes } from "@/utils";
import videos from "../../../public/content/videos.json";
import Button from "./Button";
import SmallVideoCard from "./SmallVideoCard";
import { sendGTMEvent } from "../Analytics";

interface VideoCardDescriptionProps {
    title?: string;
    description?: string;
}

export default function VideoCardDescription({
    title,
    description,
}: VideoCardDescriptionProps) {
    const videos_count = videos.videos.reduce(
        (total, module) => total + Number.parseInt(module.video_count),
        0,
    );
    const videos_duration = videos.videos.reduce(
        (total, module) => total + formatDurationToMinutes(module.duration),
        0,
    );

    return (
        <>
            <div className="lg:w-[408px]  w-82 min-h-[522px] border lg:px-7 border-gray-100 px-4  py-7 rounded-md">
                <div className="flex flex-col space-y-2 justify-center items-center">
                    <SmallVideoCard
                        img="/images/RicoPlaceholder.png"
                        free={true}
                        playCenter={true}
                    />
                    <div className="self-stretch h-52  pt-10 flex-col justify-center items-start gap-2 flex">
                        <div className="self-stretch h-[130px]  flex-col justify-start items-start gap-1 flex">
                            <div className="self-stretch text-neutral-800 text-lg font-bold  leading-normal">
                                {title}
                            </div>
                            <div className="self-stretch text-neutral-800 text-xl1 font-normal  leading-8.5">
                                {description}
                            </div>
                        </div>
                        <div className="rounded justify-center pt-6 lg:pt-0 items-start gap-1 inline-flex">
                            <div className="text-neutral-800 text-base font-bold  leading-normal">
                                {formatDurationToHoursAndMinutes(videos_duration)}
                            </div>
                            <div className="text-neutral-800 font-bold  leading-tight">
                                •
                            </div>
                            <div className="text-neutral-800 text-base font-bold  leading-normal">
                                {videos.videos.length} Modules
                            </div>
                            <div className="text-neutral-800 font-bold  leading-tight">
                                •
                            </div>
                            <div className="text-neutral-800 text-base font-bold  leading-normal">
                                {videos_count} Videos
                            </div>
                            <div className="text-neutral-800 font-bold  leading-tight">
                                •
                            </div>
                        </div>

                        <Button
                            backgroundColor="bg-darkGreen"
                            hasIcon={ButtonDark.args?.hasIcon}
                            rounded={ButtonDark.args?.rounded}
                            text="Weiter zur kostenlosen Masterclass"
                            size="lg:w-[368px] w-[311px] h-20"
                            border={ButtonDark.args?.border}
                            paddings="lg:py-3 py-2 "
                            as="a"
                            href={process.env.NEXT_PUBLIC_MASTERCLASS_URL}
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title: "Masterclass",
                                    section_index: "5",
                                    cta_text: "Weiter zur kostenlosen Masterclass",
                                    cta_link: process.env.NEXT_PUBLIC_MASTERCLASS_URL,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
